import VueApexCharts from "vue-apexcharts";
import {
    getTableSellReport,
} from "@/service/reportsellcourse/reportsellcourse";
export default {
    props: {
        dataTable: {
            type: Object,
        },
    },
    components: {
        apexchart: VueApexCharts,
    },

    data() {
        return {
            tabs: "tab1",
            loading: false,
            dataHistory: [],
            dataHistoryWithdraw: [],
            pageHis: 1,
            limitHis: 10,
            maxPageHis: 1,
            pageWithdraw: 1,
            limitWithdraw: 10,
            maxPageWithdraw: 1,
            headerHistory: [
                {
                    text: "Product ID",
                    value: '_id',
                    align: 'center',
                    sortable: false,
                    width: '10%',
                },
                {
                    text: "Product name",
                    value: 'title',
                    align: 'start',
                    sortable: false,
                    width: '50%',
                },
                {
                    text: "Buyer",
                    value: 'user',
                    align: 'start',
                    sortable: false,
                    width: '15%',
                },
                {
                    text: "Date",
                    value: 'datetime',
                    align: 'center',
                    sortable: false,
                    width: '15%',
                }
                ,
                {
                    text: "Price",
                    value: 'price',
                    align: 'center',
                    sortable: false,
                    width: '15%',
                }

            ],
            headerHistoryWithdraw: [
                {
                    text: "ชื่อธนาคาร",
                    value: 'name',
                    align: 'center',
                    sortable: false,
                    width: '30%',
                },
                {
                    text: "เลขบัญชี",
                    value: 'id',
                    align: 'center',
                    sortable: false,
                    width: '25%',
                },
                {
                    text: "วันที่ถอนเงิน",
                    value: 'datetime',
                    align: 'center',
                    sortable: false,
                    width: '25%',
                },
                {
                    text: "จำนวนเงินที่ถอน",
                    value: 'money',
                    align: 'center',
                    sortable: false,
                    width: '20%',
                }

            ],
        }
    },
    mounted() {
        this.initialize()
    },
    watch: {
        dataTable(value) {
            this.dataTable = value
            this.initialize()

        },
    },
    methods: {
        formatDate(datatime) {

            let date = new Date((datatime))
            let monthNamesThai = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.",
                "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."]
            var Str =
                date.getDate()
                + " " + monthNamesThai[(date.getMonth())]
                + " " + (date.getFullYear() + 543) +
                " เวลา " + ("00" + (date.getHours())).slice(-2) + ":" + ("00" + (date.getMinutes())).slice(-2) + " น."
            return Str
        },
        async changePageHistory(page) {
            console.log(page)
            this.pageHis = page;
            await this.getListHistLib()
        },
        async changePageWithdraw(page) {
            console.log(page)
            this.pageWithdraw = page;
            await this.getListWithdraw()
        },

        async initialize() {
            let resultDataHis = this.dataTable
            let dataHis = resultDataHis.data ? resultDataHis.data : []
            this.maxPageHis = resultDataHis.maxPage ? resultDataHis.maxPage : 0
            console.log(this.dataTable.data)
            await dataHis.forEach(async (Item, index) => {
                this.dataHistory.push({
                    _id: Item.course._id,
                    title: Item.course.title,
                    user: Item.student.email,
                    datetime: await this.formatDate(Item.created_at),
                    price: Item.pricing + " บาท"
                });
            })

            for (let index = 0; index < 10; index++) {
                this.dataHistoryWithdraw.push({
                    name: "ธนาคารกสิกรไทย",
                    id: "xxx-xxx-294" + index,
                    datetime: "12 ก.ค. 2563 เวลา 12:34 น.",
                    money: "฿235.00"
                });
            }
        },
        async getListHistLib() {
            this.loading = true
            let params = {
                page: this.pageHis,
                limit: this.limitHis
            }
            this.dataTable = await getTableSellReport(params)
            console.log(this.dataTable)
            this.dataHistory = [];
            this.maxPageHis = this.dataTable.maxPage
            console.log(this.maxPageHis)
            await this.dataTable.data.forEach(async (Item, index) => {
                this.dataHistory.push({
                    _id: Item.course._id,
                    title: Item.course.title,
                    user: Item.student.email,
                    datetime: await this.formatDate(Item.created_at),
                    price: Item.pricing + " บาท"
                });
            })

            this.loading = false
        },
        async getListWithdraw() {
            this.loading = true
            let params = {
                page: this.pageHis,
                limit: this.limitHis
            }
            // this.dataTable = await getTableSellReport(params)
            // console.log(this.dataTable)
            this.dataHistoryWithdraw = [];
            this.maxPageWithdraw = this.dataTable.maxPage
            await this.dataTable.data.forEach(async (Item, index) => {
                this.dataHistoryWithdraw.push({
                    name: "ธนาคารกสิกรไทย",
                    id: "xxx-xxx-294" + index,
                    datetime: "12 ก.ค. 2563 เวลา 12:34 น.",
                    money: "฿235.00"
                });
            })
            this.loading = false
        }
    }
}